module.exports = __webpack_public_path__ + "assets/images/openClosedOfficePlan-04.c9c165cc08fa5da85996e81943dcc43d.svg";